export const ACCARDION_LOADER_SIZE = 30;
export const ACCARDION_LOADER_SIZE_EXPANDED = 73;
